import React, { useState, useEffect, useRef } from 'react'
import generalController from '../../../controllers/generalController'
import { convertPostalToCoordinates } from '../../../utils/googleMapHelper'
import { fetchDealerData, fetchModelData } from '../../../controllers/ActionController'
import TradeInEstimator from './TradeInEstimator'
import { localStorageKeys } from '../../../utils/constants'
import { setItemOnLocalStorage } from '../../../utils/helpers'

// HOC for "TradeInEstimator" component
function TradeInEstimatorContainer(props) {
  const [isLoading, setIsLoading] = useState(true);

  const [vehicleData, setVehicleData] = useState(null);
  const [dealerData, setDealerData] = useState(null);
  const [userLocation, setUserLocation] = useState(null);

  const componentRef = useRef(null)

  useEffect(() => {
    handleInitData();
  }, [])

  // Handle initial data with URL params.
  const handleInitData = async () => {
    const params = generalController.getURLSearchParams();

    let dealerCode = params.dealerCode;
    if (typeof window.mzFunc === 'object' && dealerCode === undefined) {
       dealerCode = mzFunc.checkCookie('preferredDealer')
    }
   

    let initUserPosition = null;

    // Vehicle
    if (params.model) {
      const modelParam = decodeURI(params.model).trim();
      const modelParamData = modelParam.split('|');

      if (modelParamData[0] && modelParamData[1]) {
        const initVehicleData = await fetchModelData(modelParamData[0], modelParamData[1]);

        if (initVehicleData) {
          setVehicleData(initVehicleData);
        }
      }
    }

    // Dealer
    if (dealerCode !== undefined && dealerCode !== '') {
      const dealerData = await fetchDealerData(dealerCode);

      if (dealerData && dealerData.dealer) {
        const { userPosition } = dealerData;

        setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData.dealer)
        setDealerData(dealerData);

        // Set dealer geolocation as user location (map center).
        if (userPosition && (userPosition.lat && userPosition.lng)) {
          initUserPosition = userPosition;
        }
      }
    }

    // Location
    if (!initUserPosition) {
      if (params.geolocation) {
        const locationParam = decodeURI(params.geolocation).trim();
        const locationParamDecoded = locationParam.split('|');

        if (locationParamDecoded[0] && locationParamDecoded[1]) {
          initUserPosition = { lat: Number(locationParamDecoded[0]), lng: Number(locationParamDecoded[1]) };
        }
      } else if (params.postalcode) {
        initUserPosition = await convertPostalToCoordinates(params.postalcode);
      }
    }

    if (initUserPosition) {
      setUserLocation(initUserPosition);
    }

    setIsLoading(false);
  }

  return (
    <div className="mz-trade-in-estimator-container mz-page-top" ref={componentRef}>
      {
        !isLoading && (
          <TradeInEstimator
            preDefinedVehicleData={vehicleData}
            preDefinedDealerData={dealerData}
            preDefinedUserLocation={userLocation}
            containerRef={componentRef}
            {...props}
          />
        )
      }
    </div>
  )
}

export default TradeInEstimatorContainer